<template>
  <div
    v-scroll-lock="true"
    class="modal active"
  >
    <div class="modal-overlay"></div>

    <div class="modal-container modal-form modal-form--sm">
      <header class="modal-header modal-form__header">
        <a
          aria-label="close"
          class="btn btn-clear float-right modal-form__close"
          @click="close()"
        >
        </a>

        <!-- <h1 class="modal-form__title">&nbsp;</h1> -->
      </header>

      <article id="print" class="modal-body modal-form__body">
        <div class="modal-form__wrapper receipt">
          <transition name="fade">
            <dr-loader
              v-if="ui.isLoading"
              size="lg"
              class="receipt__loader"
            />
          </transition>

          <transition-group name="fade">
            <div
              v-if="!ui.isLoading"
              key="receipt-header"
              class="receipt__header"
            >
              <h1 class="receipt__title">
                Recibo
              </h1>

              <img
                class="receipt__logo"
                src="@/assets/img/home/logo_web.png"
                width="150"
              />
            </div>

            <dl
              v-if="!ui.isLoading"
              key="receipt-details"
              class="receipt__items"
            >
              <template
                v-for="(field, index) in receipt"
              >
                <dt
                  :key="`fieldName-${index}`"
                  class="receipt__term"
                >
                  {{ field.key }}
                </dt>

                <dd
                  v-html="field.value"
                  :key="`fieldValue-${index}`"
                  class="receipt__info"
                />
              </template>
            </dl>
          </transition-group>
        </div>
      </article>

      <transition name="fade">
        <footer
          v-if="!ui.isLoading"
          class="modal-form__footer"
        >
          <button
            class="modal-form__btn-primary"
            @click="ui.showSendEmail = true"
          >
            Enviar por e-mail
          </button>

          <button
            class="modal-form__btn-secondary"
            @click="printReceipt()"
          >
            Imprimir
          </button>
        </footer>
      </transition>
    </div>

    <print-template
      v-if="ui.isPrint"
      :agenda="1"
      :active="ui.isPrint"
      :formData="receipt"
      type="receipt"
    />

    <dr-receipt-send-email
      v-if="ui.showSendEmail"
      :id="id"
      :email.sync="email"
      @close="ui.showSendEmail = false"
    />
  </div>
</template>

<script>
import DrReceiptSendEmail from '@/components/layout/appointments/receiptSendEmail'
import { mapGetters } from 'vuex'

export default {
  name: 'DrReceipt',

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  components: {
    DrReceiptSendEmail
  },

  data () {
    return {
      ui: {
        showSendEmail: false,
        isLoading: false,
        isPrint: false
      },
      receipt: null,
      email: null
    }
  },

  computed: {
    ...mapGetters({
      doctor: 'getProfile'
    })
  },

  created () {
    this.$moment.locale('PT-BR')
  },

  mounted () {
    this.getReceipt()
  },

  methods: {
    getReceipt () {
      const url = `/agenda/${this.id}/payment_receipt`

      this.ui.isLoading = true
      this.fn_SHOW_PROGRESS()
      this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then(res => this.handleData(res.data))
        .catch((err) => {
          console.log(err)
          this.close()
          this.fn_HANDLE_ERROR(err)
        })
        .finally(() => {
          this.ui.isLoading = false
          this.fn_HIDE_PROGRESS()
        })
    },

    handleData (data) {
      const doctor = data['doctor']['display_name']

      const specialties = data['doctor']['medical_specialties']
        .map(specialty => specialty.name
          .split(/\s/)
          .map(w => w.charAt(0).toUpperCase() + w.substring(1).toLowerCase())
          .join(' ')
        )
        .join(', ')

      const office = data['doctor_office']['name']

      const { cep, city, complement, district, number, street, uf } = data['doctor_office']['address'] ||
        { cep: null, city: null, complement: null, number: null, street: null, uf: null }

      const officeAddress = cep
        ? `${street}, ${number} ${
          complement ? `, ${complement}` : ''
        }- ${district}<br>${this.$filters.TO_CEP(cep)} ${city.name} - ${uf.name}`
        : null

      const appointmentStart = this.$moment(data['appointment_start'])
      const appointmentFinish = this.$moment(data['appointment_finish'])

      const date = `${
        appointmentStart.format('D [de] MMMM [de] YYYY[,] HH[h]mm')
      } - ${
        appointmentStart.isSame(appointmentFinish, 'day')
          ? `${appointmentFinish.format('HH[h]mm')}`
          : `${appointmentFinish.format('D [de] MMMM [de] YYYY[,] HH[h]mm')}`
      }`

      const value = `${data['payment_installment']}x de R$ ${this.$filters.TO_BRL(data['value'])}`

      const { name, cpf } = data['user'] || data['special_patient']

      this.receipt = [
        { key: 'Médico', value: doctor, order: 0 },
        { key: 'Especialidade', value: specialties, order: 1 },
        { key: 'Consultório', value: office, order: 2 },
        { key: 'Data', value: date, order: 4 },
        { key: 'Valor', value: value, order: 5 },
        { key: 'Paciente', value: name, order: 6 },
        { key: 'CPF', value: this.$filters.TO_CPF(cpf) || '(não informado)', order: 7 }
      ]

      if (officeAddress) this.receipt.push({ key: 'Endereço', value: officeAddress, order: 3 })

      this.receipt = this.receipt.sort((a, b) => a.order > b.order)

      this.email = data['user'] ? data['user']['email'] : data['special_patient']['email']
    },

    printReceipt () {
      this.$htmlToPaper('print', () => {
        console.log('teste')
        // this.$emit('cancel', true)
      })
    },

    close () {
      this.receipt = null
      this.$emit('close')
    }
  }
}
</script>
